import { ISelectOption } from "core-integration/src/store";

export const getSelectedOption = ({
  filterOptions,
  selectedOption,
}: {
  filterOptions: ISelectOption[];
  selectedOption: number | string;
}) => {
  const match = filterOptions.find(
    ({ value }) => value === selectedOption.toString(),
  )!;
  return { value: match.value.toString(), label: match.label };
};

export const getModifiedFilterIds = (
  controls: { entry: number; event: number },
  defaultFilters: { entry: number; event: number },
) => {
  const modifiedFilters: Record<string, boolean> = {};
  if (controls.event !== defaultFilters.event) {
    modifiedFilters.event = true;
  }

  if (controls.entry !== defaultFilters.entry) {
    modifiedFilters.entry = true;
  }

  return modifiedFilters;
};
